import { createApi,   } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../core/api/axiosBaseQuery';
import { DashboardStatisticsResponse } from '../types/types';
 
export const ENROLLMENT_BASE_API_ENDPOINT = '/api/v1';
export const dashboardApi = createApi({
    reducerPath: 'dashboardApi',
    baseQuery: axiosBaseQuery({ baseUrl: ENROLLMENT_BASE_API_ENDPOINT }),
    endpoints: (builder) => ({
        getDashboardStatistics: builder.query<DashboardStatisticsResponse, void>({
            query: () => ({
                url: '/students/statics',
                method: 'GET',
            }),
            transformResponse: (response: DashboardStatisticsResponse) => {
                return response;
            },
             
        }),
        // Add more endpoints as needed
    }),
});

export const { useGetDashboardStatisticsQuery } = dashboardApi;